/**
 * Compile-time UI kill-switches.
 *
 * `TAGS_UI_ENABLED` hides the web-facing tag surfaces (settings tag manager,
 * its nav entry, and the per-item Tags section in the asset-item detail
 * dialog) while keeping the tag API and the asset_item `is_refurbished`
 * dual-write fully active. Flip to `true` to bring the UI back.
 */
export const TAGS_UI_ENABLED = false;
